import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import TranslatedText from "./TranslatedText";
import ConfigsIcon from "@material-ui/icons/Settings";
import LockUnlockInstallation from "./LockUnlockInstallation";
import ForceProvisioningError from "./ForceProvisioningError";
import ForceProvisioningSucceeded from "./ForceProvisioningSucceeded";
import DeleteButton from "./DeleteButton";
import StopOperationButton from "./StopOperationButton";
import { POLICY_INSTALLATIONS } from "../common/rolesManagement";
import { InstallationEventStatus } from "../common/statuses";

class AdvancedDialogButton extends React.Component {
    state = {
        open: false
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    myDialog(props) {
        const data = this.props.data;
        const permissions = this.props.permissions;
        return (
            <React.Fragment>
                {data &&
                    permissions.includes(POLICY_INSTALLATIONS.LOCK) &&
                    data.status !== InstallationEventStatus.UpdateStarted && (
                        <tr align="center">
                            <LockUnlockInstallation
                                resource_id={data.id}
                                lock={data.locked}
                            />
                        </tr>
                    )}
                {data &&
                    data.can_force_provisioning &&
                    permissions.includes(
                        POLICY_INSTALLATIONS.FORCE_PROVISIONING_SUCCEEDED
                    ) &&
                    data.status !== InstallationEventStatus.UpdateStarted && (
                        <tr align="center">
                            <ForceProvisioningSucceeded
                                resource_id={data.id}
                                can_force_provisioning={
                                    data.can_force_provisioning
                                }
                            />
                        </tr>
                    )}
                {data &&
                data.can_force_provisioning && // if can force provisioning also can force error
                    permissions.includes(
                        POLICY_INSTALLATIONS.FORCE_PROVISIONING_FAILED
                    ) &&
                    data.status !== InstallationEventStatus.UpdateStarted && (
                        <tr align="center">
                            <ForceProvisioningError
                                resource_id={data.id}
                                can_force_provisioning={
                                    data.can_force_provisioning
                                }
                            />
                        </tr>
                    )}
                {//StopOperationButton (used for stop operation)//
                permissions &&
                    permissions.includes(
                        POLICY_INSTALLATIONS.STOP_OPERATION
                    ) && (
                        <tr align="center">
                            <StopOperationButton resource_id={data.id} />
                        </tr>
                    )}
                {//ForceDeleteButton (used for force delete)//
                data &&
                    permissions &&
                    permissions.includes(POLICY_INSTALLATIONS.FORCE_DELETE) &&
                    data.status !== InstallationEventStatus.UpdateStarted && (
                        <tr align="center">
                            <DeleteButton
                                undoable={false}
                                basePath={this.props.basePath}
                                resource="installations"
                                message={
                                    "resources.installations.actions.force_delete_started"
                                }
                                record={data}
                                text={"Forza cancellazione"}
                                dialogContentTitle={
                                    "resources.installations.actions.force_delete"
                                }
                                dialogContentText={
                                    "resources.installations.actions.force_delete_warning"
                                }
                                redirect="installations"
                            />
                        </tr>
                    )}
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <Button
                    color="primary"
                    target="_blank"
                    onClick={this.handleClickOpen}
                >
                    <Tooltip
                        title={
                            <TranslatedText
                                resource_name={`resources.installations.actions.advanced`}
                            />
                        }
                    >
                        <ConfigsIcon style={{ paddingRight: "0.4em" }} />
                    </Tooltip>
                    AVANZATE
                </Button>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.open}
                >
                    <DialogTitle id="form-dialog-title">
                        <b>
                            <TranslatedText
                                resource_name={`resources.installations.fields.advanced`}
                            />
                        </b>
                    </DialogTitle>
                    <DialogContent
                        style={{
                            overflow: "visible",
                            overflowY: "visible"
                        }}
                    >
                        {this.myDialog(this.props)}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            <TranslatedText
                                resource_name={"ra.actions.close"}
                            />
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default AdvancedDialogButton;



// WEBPACK FOOTER //
// ./src/components/AdvancedDialogButton.js